export const ResidualsMessages = {
	FileDelete:
		"Deletion of the data on this step will lead to deletion of the data further down the process. Affected steps: {File Import, Normalization, Calculation, Payouts, Reporting}.",
	ImportDelete:
		"Deletion of the data on this step will lead to deletion of the data further down the process. Affected steps: {Normalization, Calculation, Payouts, Reporting}.",
	NormalizationDelete:
		"Deletion of the data on this step will lead to deletion of the data further down the process. Affected steps: {Calculation, Payouts, Reporting}. ",
	DataCleanseRefresh:
		"Refreshing data cleanse requires normalization process update. Proceeding with this action will lead to merchants back up data update, calculations remove and payouts update. Are you sure you want to proceed?",
	CalculationReRun:
		"If any part of remaining residuals process is already complete, re-running calculations may update the data related to any agents or MIDs for which calculations are re-run. Proceed?",
	ProceedMessage: "Are you sure you want to proceed?",
};
